import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { type AanvragenRelatiesGetInTeVullenRelatieGegevensByOffertenummerDto as InTeVullenRelatieGegevens } from '@services/aanvragen-public/orval-api/model/aanvragenRelatiesGetInTeVullenRelatieGegevensByOffertenummerDto';
import { CrmRelationsRelatieContext } from '@services/crm-public/orval-api/model/crmRelationsRelatieContext';

export const useRelatieStuurgegevensStore = defineStore('RelatieStuurgegevensStore', () => {
  const inTeVullenOfferteRelatieGegevens = ref<InTeVullenRelatieGegevens>({
    magRelatieKiezen: false,
    betalingOpties: [],
    isJaarbetaling: false,
    vraagBetalingsgegevens: false,
  });

  const accepterendTussenpersoonNr = ref(0);
  const incassantId = ref<string>();
  const isWebmodule = ref(false);
  const isWebVersie = ref(false);
  const naamAdviseur = ref('');
  const surebusinessAccepteert = ref(false);
  const tenaamstelling = ref('');
  const adviseurIncasseert = ref(false);
  const vragenInJeVormStellen = ref(false);
  const relatieContext = ref<CrmRelationsRelatieContext>();

  const isVoorlopigeDekking = computed(
    () => relatieContext.value === CrmRelationsRelatieContext.VoorlopigeDekking,
  );

  const inTeVullenRelatieGegevens = computed(() => ({
    vraagSbicode: !isWebVersie.value,
    vraagBetalingsgegevens: relatieContext.value === CrmRelationsRelatieContext.Aanvraag,
    vraagRechtsgeldigVertegenwoordiger: !isVoorlopigeDekking.value,
    vraagContactgegevens: !isVoorlopigeDekking.value,
    vraagRelatieType: !isVoorlopigeDekking.value,
  }));
  return {
    inTeVullenOfferteRelatieGegevens,
    inTeVullenRelatieGegevens,
    accepterendTussenpersoonNr,
    incassantId,
    isWebmodule,
    isWebVersie,
    naamAdviseur,
    surebusinessAccepteert,
    tenaamstelling,
    adviseurIncasseert,
    vragenInJeVormStellen,
    relatieContext,
    isVoorlopigeDekking,
  };
});
